import * as get from './reducers/get';
import * as removeLiability from './reducers/remove';
import * as multiple from './reducers/multiple';
import * as alerts from './reducers/alert';
import * as multiples from './reducers/multiples';
import * as multiplesDetails from './reducers/multiples-line-details';
import * as removeMultipleLiability from './reducers/removeMultiple';
import * as legsRum from './reducers/last-legs-rum';
import * as avgNetPayouts from './reducers/avg-net-payout';

import { simple } from 'src/utils/reducers';

// eslint-disable-next-line import/no-default-export
export default simple({
    MARKETS_GET_LIABILITIES_REQUEST: get.request,
    MARKETS_GET_LIABILITIES_ERROR: get.error,
    MARKETS_GET_LIABILITIES_FINISH: get.finish,
    MARKETS_REMOVE_LIABILITIES_REQUEST: removeLiability.request,
    MARKETS_GET_MULTIPLE_LIABILITIES_REQUEST: multiple.request,
    MARKETS_GET_MULTIPLE_LIABILITIES_ERROR: multiple.error,
    MARKETS_GET_MULTIPLE_LIABILITIES_FINISH: multiple.finish,
    MARKETS_REMOVE_MULTIPLE_LIABILITIES_REQUEST: removeMultipleLiability.request,

    GET_LIABILITY_ALERTS: alerts.request,
    FINISH_LIABILITY_ALERTS: alerts.finish,
    ERROR_LIABILITY_ALERTS: alerts.error,

    GET_MULTIPLES: multiples.request,
    FINISH_MULTIPLES: multiples.finish,
    ERROR_MULTIPLES: multiples.error,

    GET_LEGS_RUM: legsRum.request,
    ERROR_LEGS_RUM: legsRum.error,
    FINISH_LEGS_RUM: legsRum.finish,

    GET_AVG_NET_PAYOUTS: avgNetPayouts.request,
    ERROR_AVG_NET_PAYOUTS: avgNetPayouts.error,
    FINISH_AVG_NET_PAYOUTS: avgNetPayouts.finish,

    GET_MULTIPLES_LINE_DETAILS: multiplesDetails.request,
    FINISH_MULTIPLES_LINE_DETAILS: multiplesDetails.finish,
    ERROR_MULTIPLES_LINE_DETAILS: multiplesDetails.error,
});
